
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events-hub",
      function () {
        return require("private-next-pages/events-hub/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events-hub"])
      });
    }
  